import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-483f2014"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 ant-col-xxl-24" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESA:")
], -1))
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_12 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-24 ss-card ss-card-space ss-alinhar-texto-esquerda",
  style: {"min-height":"40%"}
}
const _hoisted_19 = { class: "ant-table-column-title" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ant-table-column-sorter ant-table-column-sorter-full" }, null, -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "acoes-item"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = { key: 4 }
const _hoisted_28 = {
  key: 5,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Dt Emissão:", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa: ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_selecionar_tipo_nota_fiscal = _resolveComponent("selecionar-tipo-nota-fiscal")!
  const _component_selecionar_filtro_periodo_movimento_comercial = _resolveComponent("selecionar-filtro-periodo-movimento-comercial")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_status_nota_emitida = _resolveComponent("selecionar-status-nota-emitida")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_card = _resolveComponent("card")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_enviar_email_pessoa_modal = _resolveComponent("enviar-email-pessoa-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: 'VENDAS',
          tituloRecurso: _ctx.state.tituloRecurso,
          exibirAtalhosTela: false,
          exibirHistoricoTela: true,
          empresasSelecionadas: [_ctx.dadosEmpresa.codigoEmpresa]
        }, null, 8, ["tituloRecurso", "empresasSelecionadas"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_a_select, {
                  value: _ctx.dadosEmpresa.codigoEmpresa,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dadosEmpresa.codigoEmpresa) = $event)),
                  options: _ctx.telaBase.empresasDisponiveis,
                  style: {"width":"100%"},
                  optionFilterProp: "label",
                  onChange: _ctx.atualizarSelecaoEmpresas,
                  disabled: true
                }, null, 8, ["value", "options", "onChange"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_selecionar_tipo_nota_fiscal, {
                  valor: _ctx.state.tipoNotaFiscal,
                  "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.tipoNotaFiscal) = $event)),
                  disabled: false,
                  "radio-button": false
                }, null, 8, ["valor"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_selecionar_filtro_periodo_movimento_comercial, {
                  valor: _ctx.state.periodo,
                  "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.periodo) = $event)),
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.periodoAlterado()))
                }, null, 8, ["valor"]),
                ((_ctx.state.periodo === _ctx.EFiltroPeriodoMovimentoComercial.Personalizado))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_a_form_item, {
                          label: "Data Inicial e Final",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_data_inicial_final, {
                              dataInicialSelecionada: _ctx.state.dataInicialSelecionada,
                              "onUpdate:dataInicialSelecionada": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.dataInicialSelecionada) = $event)),
                              dataFinalSelecionada: _ctx.state.dataFinalSelecionada,
                              "onUpdate:dataFinalSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.dataFinalSelecionada) = $event)),
                              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.buscarNotasFiscais()))
                            }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_selecionar_status_nota_emitida, {
                  valor: _ctx.state.statusNotaFiscal,
                  "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.statusNotaFiscal) = $event)),
                  disabled: false,
                  "radio-button": false
                }, null, 8, ["valor"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_a_button, {
                  type: "ant-btn ant-btn-primary ss-btn-tela",
                  onClick: _ctx.buscarNotasFiscais
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Buscar")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_a_button, {
                  type: "ant-btn ant-btn-primary ss-btn-tela",
                  onClick: _ctx.exportarXMLs
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Exportar XML")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_table, {
              style: {"margin-top":"5px"},
              columns: _ctx.state.colunas.filter(item => item.visible),
              "data-source": _ctx.state.notasFiscais,
              rowKey: "codigo",
              pagination: false,
              loading: _ctx.telaBase.carregando,
              scroll: _ctx.state.telaMobile ? null :{ x: (_ctx.gradeBase.windowWidth), y: _ctx.defineAlturaScroll(50) },
              "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.mudarSelecao},
              size: "small"
            }, {
              headerCell: _withCtx(({ column }) => [
                (column.ordering)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: column.key,
                      class: "ss-coluna-ordenada"
                    }, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(column.title), 1),
                      _hoisted_20
                    ]))
                  : _createCommentVNode("", true)
              ]),
              bodyCell: _withCtx(({ column, text, record }) => [
                (column.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(text), 1))
                  : (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("a", {
                          class: "email",
                          onClick: ($event: any) => (_ctx.apresentarEnvioEmail(record.codigo))
                        }, [
                          _createVNode(_component_icone, { nome: "email" })
                        ], 8, _hoisted_23),
                        _createElementVNode("a", {
                          class: "imprimir",
                          onClick: ($event: any) => (_ctx.imprimir(record.codigo))
                        }, [
                          _createVNode(_component_icone, { nome: "imprimir" })
                        ], 8, _hoisted_24)
                      ]))
                    : (column.customRenderRow === _ctx.ECustomRenderRow.MascararCPFCNPJ)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(text)), 1))
                      : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                        : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                          : (column.key === 'NotaFiscal')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("span", null, [
                                  _createElementVNode("b", null, [
                                    _createElementVNode("span", null, "Nº: " + _toDisplayString(record.numeroNotaFiscal), 1)
                                  ])
                                ]),
                                _createElementVNode("span", null, [
                                  _hoisted_29,
                                  _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(record.dataEmissao)), 1)
                                ]),
                                _createElementVNode("span", null, [
                                  _hoisted_30,
                                  _createTextVNode(_toDisplayString(_ctx.obterNomeRazaoSocialPessoa(record)), 1)
                                ]),
                                _createElementVNode("span", null, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.totalNotaFiscal, 2)), 1),
                                _createElementVNode("span", null, [
                                  _createVNode(_component_a_tag, {
                                    class: _normalizeClass('ss-tag-status ' + _ctx.obterClasseStatus(record.descricaoStatus))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(record.descricaoStatus), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
              ]),
              emptyText: _withCtx(() => [
                _createVNode(_component_mensagem_sem_dados, {
                  resultadoPesquisa: !_ctx.telaBase.carregando,
                  mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum registro foi encontrado com estes filtros!'
                }, null, 8, ["resultadoPesquisa", "mensagem"])
              ]),
              _: 1
            }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_preview_pdf, {
        arquivos: _ctx.state.arquivosPdf
      }, null, 8, ["arquivos"]),
      _createVNode(_component_enviar_email_pessoa_modal, {
        visivel: _ctx.state.apresentarEnvioEmail,
        "onUpdate:visivel": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.apresentarEnvioEmail) = $event)),
        empresa: _ctx.state.empresaSelecionada,
        codigoPessoa: _ctx.state.codigoPessoaEmail,
        tituloModal: 'Confirme para quais E-mails deseja enviar a NF-e: ' + _ctx.state.notaFiscalEnvioEmail.numero,
        onEnviarEmail: _ctx.enviarEmailNFe
      }, null, 8, ["visivel", "empresa", "codigoPessoa", "tituloModal", "onEnviarEmail"])
    ])
  ]))
}